import FieldText from "../../../generic/text/text"

import FieldTimeReportMessage_Editable from "./render/editable"
import FieldTimeReportMessage_TableCell from "./render/table/table-cell"
import TimeReport from "../../../../model2/time-report/time-report"

export default class FieldTimeReportMessage extends FieldText {

    constructor(config:any) {
        super(config)

        this.renderComponents.editable  = FieldTimeReportMessage_Editable
        this.renderComponents.tableCell = FieldTimeReportMessage_TableCell
    }

    canEdit(model: TimeReport):boolean {
        return model.canEdit
    }
}
